import { Typography } from "@material-ui/core";
import styled from "styled-components";

const StyledWrapper = styled.div<{}>`
  display: grid;
  grid-template-columns: minmax(auto, 215px) minmax(auto, 215px) auto 1fr;
  gap: ${props => props.theme.spacing(1, 3)};
  margin-bottom: ${props => props.theme.spacing(3)}px;

  .supervisor {
    grid-area: 5/1/5/3;
  }

  .birth-date {
    grid-area: 3/1/3/3;
  }

  .email {
    grid-area: 2/1;
  }

  .error-first-name {
    grid-area: 1/3;
  }

  .error-last-name {
    grid-area: 1/4;
  }

  .error-email {
    grid-area: 2/3;
  }

  .error-phone {
    grid-area: 2/4;
  }

  .phone {
    grid-area: 2/2;
  }
  .anniversary-date {
    grid-area: 6/1;
  }

  .company-id {
    grid-area: 6/1/6/3;
  }

  .contract-type {
    grid-area: 4/1;
  }

  .error-company-id {
    grid-area: 6/3;
  }

  .is-active {
    grid-area: 4/2;
  }

  @media (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
    gap: ${props => props.theme.spacing(1, 3)};

    .error-first-name {
      grid-area: 2/1;
    }

    .error-last-name {
      grid-area: 2/2;
    }

    .email {
      grid-area: 3/1;
    }

    .error-email {
      grid-area: 4/1;
    }

    .phone {
      grid-area: 3/2;
    }

    .error-phone {
      grid-area: 4/2;
    }

    .birth-date {
      grid-area: 5/1/5/3;
    }

    .contract-type {
      grid-area: 6/1;
    }

    .error-company-id {
      grid-area: 8/1;
    }

    .supervisor {
      grid-area: 7/1;
    }

    .company-id {
      grid-area: 7/2;
    }

    .anniversary-date {
      grid-area: 8/1;
    }

    .is-active {
      grid-area: 6/2;
    }
  }

  ${props => props.theme.breakpoints.down("xs")} {
    grid-template-columns: 1fr;
    gap: ${props => props.theme.spacing(0, 3)};

    & > div {
      grid-area: auto !important;
      margin-bottom: ${props => props.theme.spacing(2)}px;

      &.error-first-name {
        grid-area: 2 !important;
      }
      &.error-email {
        grid-area: 6 !important;
      }
    }
  }
`;

const StyledError = styled.div`
  color: ${props => props.theme.colors.red};
  align-self: flex-end;
  padding-bottom: ${props => props.theme.spacing(1)}px;
  font-style: italic;
  display: flex;

  @media (max-width: 1000px) {
    padding: 0;
    position: relative;
    & > * {
      font-size: 12px;
      position: absolute;
      left: 0;
      top: -8px;
    }
  }

  ${props => props.theme.breakpoints.down("xs")} {
    margin: 0 !important;
    & > * {
      top: -17px;
    }
  }
`;

const StyledLabel = styled(Typography)`
  color: ${props => props.theme.palette.secondary.main};
`;

const StyledCheckboxWrapper = styled.div`
  p {
    padding-left: 10px;
    margin-bottom: 0;
  }
`;

const StyledTitle = styled.div`
  color: ${props => props.theme.palette.secondary.main};
  margin-bottom: 9px;
  margin-top: 0px;
`;

const StyledCheckbox = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

export {
  StyledError,
  StyledLabel,
  StyledWrapper,
  StyledCheckboxWrapper,
  StyledTitle,
  StyledCheckbox,
};
